import React from "react";
import 'antd/lib/card/style/css';
import 'antd/lib/row/style/css';
import 'antd/lib/col/style/css';
import 'antd/lib/alert/style/css';
import 'antd/lib/table/style/css';
import privateRoute from "../Main/PrivateRoute";
import {connect} from "react-redux";
import getAllCertificates from "../../actions/getAllCertificates";
import getAllCertificatesBetween from "../../actions/getAllCertificatesBetween";
import deleteCertificateRequest from "../../actions/deleteCertificateRequest";
import regenCertificateRequest from "../../actions/regenCertificateRequest";
import renewCertificate from "../../actions/renewCertificate";
import revokeCertificate from "../../actions/revokeCertificate";
import getStatus from "../../helpers/getStatus";
import modalShow from "../../actions/modalShow";
import modalDismiss from "../../actions/modalDismiss";
import processApproval from "../../actions/processApproval";
import generateP12 from "../../actions/generateP12";
import languages from "../../language/languages";

import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    DislikeOutlined,
    EllipsisOutlined,
    LikeOutlined,
    QuestionCircleOutlined,
    WarningOutlined,
    DownloadOutlined,
    SearchOutlined,
    ClearOutlined
} from '@ant-design/icons';

import {
    Button,
    Table,
    ConfigProvider,
    Select,
    Row,
    Input,
    Col,
    DatePicker,
    Checkbox,
    Tooltip,
} from "antd";
import Dropdown from "antd/es/dropdown";
import {CERT_DETAILS_MODAL, CRL_REASONS_MODAL, MESSAGE_MODAL} from "../Modal/types";
import enUS from 'antd/es/locale/en_US';
import esCO from 'antd/es/locale/es_ES';
import moment from "moment";
import certificateTypes from "../../language/certificateTypes";

const { Column } = Table;
const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

class CertificatesList extends React.Component
{

    state = {
        loaded:false,
        filtered:false,
        selectedField:'serialnumber',
        selectedOperator:'=',
        selectedValue:'',
        data: [],
        filters:{},
        history:false,
        pagination: {current:1,size:'small',defaultCurrent:1,showSizeChanger:true,pageSizeOptions:['10', '50', '100']}
    };

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if(!this.state.loaded)
            this.startLoading();
    }

    componentDidMount()
    {
        this.startLoading();
    };

    startLoading=()=>
    {
        this.setState({loaded:true},()=> {
            this.handleTableChange(this.state.pagination, this.state.filters, null,null);
        });
    };

    isEmpty=(obj) =>
    {
        for(let key in obj)
        {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    };

    handleTableChange = (pagination, filters, sorter,extra, exportCerts=false) => {
        if(!filters || this.isEmpty(filters))
            filters=this.state.filters;
        if(sorter)
            sorter=null;
        const pager = { ...this.state.pagination };
        let pageSize=pagination.pageSize;
        if(!pageSize || pageSize<1)
            pageSize=this.getDefaultPageSize();
        pager.current = pagination.current;
        pager.pageSize=pageSize;
        this.setState({
            pagination: pager,
        });
        if(filters && filters.whereColumn && (filters.whereColumn==='notafter' || filters.whereColumn==='date' || filters.whereColumn==='issuedate'))
        {
            this.props.getAllCertificatesBetween({
                limit: pageSize,
                page: pagination.current,
                orderColumn: 'date',
                asc: 'false',
                history: this.state.history,
                export:exportCerts,
                ...filters,
            },this.onFinishGetCertificates,this.onCertificatesError);
        }
        else {
            this.props.getAllCertificates({
                limit: pageSize,
                page: pagination.current,
                orderColumn: 'date',
                asc: 'false',
                history: this.state.history,
                export:exportCerts,
                ...filters,
            }, this.onFinishGetCertificates, this.onCertificatesError);
        }
    };

    onCertificatesError= () =>
    {
        this.setState({data:[]});
    };

    getDefaultPageSize=()=>
    {
        return window.innerHeight>850?'20':'10';
    };

    onFinishGetCertificates= (data) =>
    {
        const pagination = { ...this.state.pagination };
        pagination.total = data.total;
        pagination.showTotal=(total) => 'Total: ' + total;
        pagination.pageSizeOptions[0]=this.getDefaultPageSize();
        let sizes=pagination.pageSizeOptions;
        let max=sizes.pop();
        let queryLimit=this.props.queryLimit;
        if(max<queryLimit)
            max=queryLimit;
        pagination.pageSizeOptions.push(max);
        this.setState({
            data: data.results,
            pagination,
        });
    };

    getIcon = (status)=>
    {
        let icon;
        switch(status)
        {
            case 'OK':
                icon=<CheckCircleOutlined style={{ fontSize: 20, color: '#0c9c1e' }} />;
                break;
            case 'PENDING':
                icon=<ClockCircleOutlined style={{ fontSize: 20, color: '#f7ac17' }} />;
                break;
            case 'PENDINGAPP':
                icon=<WarningOutlined style={{ fontSize: 20, color: '#f7ac17' }} />;
                break;
            case 'REVOKED':
                icon=<CloseCircleOutlined style={{ fontSize: 20, color: '#c70d17' }} />;
                break;
            case 'APPROVED':
                icon=<LikeOutlined style={{ fontSize: 20, color: '#0c9c1e' }} />;
                break;
            case 'REJECTED':
                icon=<DislikeOutlined style={{ fontSize: 20, color: '#c70d17' }} />;
                break;
            default:
                icon=<QuestionCircleOutlined style={{ fontSize: 20, color: '#08c' }} />;
        }
        const currentStatus=getStatus(this.props.language,this.props.isRA).find(x => x.code === status);
        let statusName=status;
        if(currentStatus)
            statusName=currentStatus.name;
        return <Tooltip title={statusName}>{icon}</Tooltip>;
    };

    getCertificateLink = (status,certid) =>
    {
        if (status === 'OK')
            return <a className={'link'} href={window.netcopkiurlid + '/servlet/userCert?certId=' + certid}>{certid}</a>;
        return <span>{certid}</span>;
    };

    deleteCert = (certid) =>
    {
        let general=this;
        let message=languages[this.props.language].confirmDelete.replace("{0}",certid);
        this.props.modalShow({
            modalType: MESSAGE_MODAL,
            modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
            componentProps: {onOK:() =>{general.props.modalDismiss();general.props.deleteCertificateRequest({certid:certid},this.resetLoad);},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
        });
    };

    regenCert = (certid) =>
    {
        let general=this;
        let message=languages[this.props.language].confirmRegen.replace("{0}",certid);
        this.props.modalShow({
            modalType: MESSAGE_MODAL,
            modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
            componentProps: {onOK:() =>{general.props.modalDismiss();general.props.regenCertificateRequest({certid:certid,sendCodes:true},general.resetLoad);},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
        });
    };

    processApproval = (certid,approve) =>
    {
        let general=this;
        let message=languages[this.props.language].confirmApprove.replace("{0}",certid);
        if(!approve)
            message=languages[this.props.language].confirmReject.replace("{0}",certid);
        this.props.modalShow({
            modalType: MESSAGE_MODAL,
            modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
            componentProps: {onOK:() =>{general.props.modalDismiss();general.props.processApproval({certid:certid,sendCodes:true,approve:approve},general.resetLoad);},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
        });
    };

    showDetails = (record) =>
    {
        let general=this,certid=record.certid;
        let title=languages[this.props.language].detailsTitle.replace("{0}",certid);
        this.props.modalShow({
            modalType: CERT_DETAILS_MODAL,
            modalProps: {footer: null, title: title},
            componentProps: {onOK:(form) =>{
                general.props.modalDismiss();
                if(form)
                    general.props.generateP12(form,general.resetLoad);
                },btnOK:languages[this.props.language].btnOK,record:record,language:this.props.language, dispatch:this.props.dispatch}
        });
    };

    renewCert = (certid) =>
    {
        let general=this;
        let message=languages[this.props.language].confirmRenew.replace("{0}",certid);
        this.props.modalShow({
            modalType: CRL_REASONS_MODAL,
            modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
            componentProps: {onOK:(reason) =>{general.props.modalDismiss();general.props.renewCertificate({certid:certid,sendCodes:true,crlReason:reason},general.resetLoad);},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
        });
    };

    revokeCert = (certid) =>
    {
        let general=this;
        let message=languages[this.props.language].confirmRevoke.replace("{0}",certid);
        this.props.modalShow({
            modalType: CRL_REASONS_MODAL,
            modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
            componentProps: {onOK:(reason) =>{general.props.modalDismiss();general.props.revokeCertificate({certid:certid,crlReason:reason},general.resetLoad);},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
        });
    };

    resetLoad = () =>
    {
       this.handleTableChange(this.state.pagination,this.state.filters,null,null)
    };

    renderOptions = (record) =>
    {
        let status=record.status,type=record.type,certid=record.certid;
        let detailsButton=<Button type="primary" className={'middle-blue rounded'} onClick={() => this.showDetails(record)}>{languages[this.props.language].detailsLabel}</Button>;
        let revokeButton=<Button type="primary" className={'middle-blue rounded'} onClick={() => this.revokeCert(certid)}>{languages[this.props.language].revokeLabel}</Button>;
        let renewButton=<Button type="primary" className={'middle-blue rounded'} onClick={() => this.renewCert(certid)}>{languages[this.props.language].renewLabel}</Button>;
        let deleteButton=<Button type="primary" className={'middle-blue rounded'} onClick={() => this.deleteCert(certid)}>{languages[this.props.language].deleteLabel}</Button>;
        let regenButton=<Button type="primary" className={'middle-blue rounded'} onClick={() => this.regenCert(certid)}>{languages[this.props.language].regenLabel}</Button>;
        let approveButton=<Button type="primary" className={'middle-blue rounded'} onClick={() => this.processApproval(certid,true)}>{languages[this.props.language].approveLabel}</Button>;
        let rejectButton=<Button type="primary" className={'middle-blue rounded'} onClick={() => this.processApproval(certid,false)}>{languages[this.props.language].rejectLabel}</Button>;
        if(type==='netcoca')
            status='';
        switch(status)
        {
            case 'OK':
                if(this.props.role!==1)
                    revokeButton=renewButton='';
                deleteButton=regenButton=approveButton=rejectButton='';
                break;
            case 'PENDING':
                if(this.props.role!==1)
                    deleteButton=regenButton='';
                revokeButton=renewButton=approveButton=rejectButton='';
                break;
            case 'PENDINGAPP':
                if(this.props.role!==1)
                    deleteButton='';
                if(this.props.role!==3)
                    approveButton=rejectButton='';
                regenButton=revokeButton=renewButton='';
                break;
            default:
                revokeButton=renewButton=regenButton=deleteButton=approveButton=rejectButton='';
        }
        return <div className={'p-20 bg-white'}>{detailsButton}{renewButton}{revokeButton}{deleteButton}{regenButton}{approveButton}{rejectButton}</div>;
    };

    renderStatus=()=>
    {
       return getStatus(this.props.language,this.props.isRA).map(d => <Option key={d.code}>{d.name}</Option>);
    };

    renderTypes=()=>
    {
        return certificateTypes[this.props.language].map(d => <Option key={d.code}>{d.name}</Option>);
    };

    getTypeLabel=(typeID)=>
    {
        let types=certificateTypes[this.props.language];
        for(let i=0;i<types.length;i++)
        {
            let type=types[i];
            if(type.code===typeID)
                return type.name;
        }
        console.warn("Tipo no encontrado",typeID);
        return '';
    };

    renderFilterColumn=()=>
    {
        switch(this.state.selectedField)
        {
            case 'date':
            case 'issuedate':
            case 'notafter':
                return (
                    <Col xs={24} md={8}>
                        <RangePicker value={this.state.selectedValue} style={{ width: 250 }} defaultValue={[moment(moment().toISOString(),dateFormat),moment(moment().toISOString(),dateFormat)]}
                                     onChange={(newDate) => this.setState({selectedValue:newDate})}/>
                        <Button style={{ marginLeft: 5 }} type="primary" shape="circle" icon={<SearchOutlined />} onClick={()=>{
                            let dates=this.state.selectedValue;
                            if(dates && dates.length===2)
                            {
                                let dateFrom=dates[0];
                                let dateTo=dates[1];
                                if(dateFrom && dateTo)
                                {
                                    let filters={...this.state.filters,whereColumn:this.state.selectedField,startDate:dateFrom.format(dateFormat),endDate:dateTo.format(dateFormat),dateFormat:dateFormat};
                                    this.setState({filtered:true,pagination: {...this.state.pagination,current: 1},filters:filters},() =>{this.handleTableChange(this.state.pagination,filters,null,null)});
                                }
                            }
                        }} />
                    </Col>
                );
            case 'status':
            case 'type':
                return <Col xs={24} md={8}>
                    <Select value={this.state.selectedValue} defaultValue="ALL" style={{ width: 250 }} onChange={(value) =>
                    {
                        let filters={...this.state.filters,whereColumn:this.state.selectedField,whereOp:'=',whereValue:value};
                        if(value==='ALL')
                        {
                            filters={...this.state.filters,whereColumn:'',whereOp:'',whereValue:'',startDate:'',endDate:''};
                        }
                        this.setState({filtered:true,selectedValue:value,pagination: {...this.state.pagination,current: 1},filters:filters},() =>{this.handleTableChange(this.state.pagination,filters,null,null)});
                    }
                    }>
                        {this.state.selectedField==='status'?this.renderStatus():this.renderTypes()}
                    </Select>
                </Col>;
            default:
                return <Col xs={24} md={8}>
                    <Input.Search
                        className={'w-100'}
                        placeholder={this.state.selectedField==='serialnumber'?languages[this.props.language].equalLabel:languages[this.props.language].containsLabel}
                        onSearch={(value)=>{
                            let whereOp="like";
                            if(this.state.selectedField==='serialnumber')
                                whereOp="=";
                            let filters={...this.state.filters,whereColumn:this.state.selectedField,whereOp:whereOp,whereValue:value};
                            let filtered=true;
                            if(value==='')
                            {
                                filtered=false;
                                filters = {...this.state.filters,whereColumn: '',whereOp: '',whereValue: '',startDate: '',endDate: ''};
                            }
                            this.setState({filtered:filtered,selectedValue:value,pagination: {...this.state.pagination,current: 1},filters:filters},() =>{this.handleTableChange(this.state.pagination,filters,null,null)});
                        }}
                        onChange={(e)=>{this.setState({selectedValue: e.target.value});}}
                        defaultValue={''}
                        value={this.state.selectedValue}
                        enterButton
                        style={{ width: 292 }}
                    />
                </Col>;
        }
    };

    handleClear=(value)=>
    {
        let selectedValue,startDate,endDate='',whereOp='like';
        if(value==='status' || value==='type')
        {
            selectedValue = 'ALL';
            whereOp='=';
        }
        if(value ==='date' || value==='issuedate' || value==='notafter')
        {
            let currentDate=moment(moment().toISOString(), dateFormat);
            startDate=endDate=currentDate.format(dateFormat);
            selectedValue = [currentDate,currentDate];
            whereOp='=';
        }
        let filters={...this.state.filters,whereColumn:value,whereOp:whereOp,whereValue:'',dateFormat:dateFormat,startDate:startDate,endDate:endDate};
        this.setState({filtered:value!=='serialnumber',selectedField:value,selectedValue:selectedValue,pagination: {...this.state.pagination,current: 1},filters:filters},()=>this.handleTableChange(this.state.pagination,this.state.filters,null,null));
    };

    renderFilters=()=>
    {
      return (
          <Row gutter={16} style={{ marginBottom: 10 }}>
              <Col xs={24} md={7}>
                  <Select dropdownMenuStyle={{maxHeight:330}} value={this.state.selectedField} defaultValue={'serialnumber'} style={{ width: 250 }}
                          onChange={(value)=>this.handleClear(value)}>
                      <Option key={'serialnumber'}>{languages[this.props.language].serialNumber}</Option>
                      <Option key={'cedula'}>{languages[this.props.language].cedula}</Option>
                      <Option key={'cn'}>{languages[this.props.language].cn}</Option>
                      <Option key={'email'}>{languages[this.props.language].email}</Option>
                      <Option key={'phone'}>{languages[this.props.language].telefono}</Option>
                      <Option key={'type'}>{languages[this.props.language].type}</Option>
                      <Option key={'status'}>{languages[this.props.language].statusLabel}</Option>
                      <Option key={'date'}>{languages[this.props.language].dateLabel}</Option>
                      <Option key={'issuedate'}>{languages[this.props.language].issuedDateLabel}</Option>
                      <Option key={'notafter'}>{languages[this.props.language].notAfterLabel}</Option>
                  </Select>
              </Col>
              {this.renderFilterColumn()}
              <Col xs={24} md={9}>
                  <Row style={window.innerWidth<=576?{marginTop:5}:{}} gutter={8}>
                      <Col xs={0} md={4}>
                      </Col>
                      <Col xs={10} md={8}>
                          {this.state.filtered?<Button block icon={<ClearOutlined />} type={'ghost'} htmlType={'button'}
                          onClick={()=>this.handleClear('serialnumber')}>{languages[this.props.language].clearLabel}</Button>:''}
                      </Col>
                      <Col xs={10} md={8}>
                          <Button block icon={<DownloadOutlined />} type={'primary'} htmlType={'button'}
                                  onClick={()=>this.handleTableChange(this.state.pagination,this.state.filters,null,null,true)}>{languages[this.props.language].export}</Button>
                      </Col>
                      <Col xs={2} md={4}>
                          <Tooltip title={languages[this.props.language].showHistoryLabel}>
                            <Checkbox checked={this.state.history} onChange={(e)=>this.setState({history:e.target.checked},()=>this.handleTableChange(this.state.pagination,this.state.filters,null,null))}/>
                          </Tooltip>
                      </Col>
                  </Row>
              </Col>
          </Row>
      );
    };

    render()
    {
        return (
            <div className="card-container h-100 p-20">
                    <h2>{this.state.history?languages[this.props.language].certificatesHTitle:languages[this.props.language].certificatesTitle}</h2>
                    <ConfigProvider locale={this.props.language==='es'?esCO:enUS}>
                        {this.renderFilters()}
                    <Table dataSource={this.state.data} pagination={this.state.pagination} onChange={this.handleTableChange} bordered>
                        <Column className={'mobile-show'} width={140} title={languages[this.props.language].serialNumber} dataIndex="certid" key="certid"
                        render={(value,record) => {return this.getCertificateLink(record.status,value)}}/>
                        {/*<Column className={'mobile-hide'} width={170} title={languages[this.props.language].dateLabel} dataIndex="date" key="date"
                                render={(value) => {return new Date(value).toLocaleString()}}/>*/}
                        <Column className={'mobile-hide'} title={languages[this.props.language].cn} dataIndex="cn" key="cn" />
                        <Column className={'mobile-hide'} title={languages[this.props.language].email} dataIndex="email" key="email" />
                        <Column className={'mobile-hide'} width={100} title={languages[this.props.language].cedula} dataIndex="cedula" key="cedula" />
                        <Column className={'mobile-show'} align={'center' } width={70} title={languages[this.props.language].statusLabel} dataIndex="status" key="status" render={value => {return this.getIcon(value)}}/>
                        <Column className={'mobile-hide'} width={150} title={languages[this.props.language].type} dataIndex="type" key="type" render={value=> this.getTypeLabel(value)} />
                        <Column className={'mobile-show'} width={70} title={languages[this.props.language].actions}
                                render={(value,record) =>
                                {return <Dropdown trigger={'click'} overlay={this.renderOptions(record)}><Button type={"primary"} style={{marginLeft: 8,height:23}}><EllipsisOutlined /></Button></Dropdown>;}}/>
                    </Table>

                    </ConfigProvider>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        language: state.auth.language,
        certStatus: state.certificates.certStatus,
        isRA:state.auth.isRA,
        role: state.auth.role,
        queryLimit:state.auth.queryLimit

    };
};
export default privateRoute(connect(mapStateToProps, {generateP12,processApproval,getAllCertificates,getAllCertificatesBetween,deleteCertificateRequest,regenCertificateRequest,renewCertificate,revokeCertificate,modalShow,modalDismiss})(CertificatesList));
